/**
 * Camada 1 · classificar o retorno de um login por provedor externo.
 *
 * ---------------------------------------------------------------------------
 * POR QUE ISTO E UMA FUNCAO PURA, E FORA DO COMPONENTE
 * ---------------------------------------------------------------------------
 * A regra de negocio nao importa nada do mundo: nem `window`, nem React, nem rede. Isso a
 * torna exercitavel em milissegundos, com os casos de borda escritos a mao, e e o que faz
 * a suite ACUSAR em vez de decorar. Dentro do componente, ela so poderia ser testada
 * subindo uma pagina inteira, e por isso deixaria de ser testada.
 */

/** O que aconteceu no retorno, do ponto de vista de quem precisa escrever a mensagem. */
export type RetornoOauth = 'sem-erro' | 'escolha-da-pessoa' | 'falha';

/**
 * Classifica o retorno lendo a QUERY e o FRAGMENTO.
 *
 * OS DOIS, e nao um: o provedor devolve o erro ora em `?error=`, ora em `#error=`,
 * dependendo do fluxo e de onde a pessoa parou. Ler apenas a query funciona na maioria dos
 * testes e falha justamente no caso que o usuario encontra.
 *
 * @param query   `window.location.search`, com ou sem o `?` na frente
 * @param hash    `window.location.hash`, com ou sem o `#` na frente
 */
export function classificarRetornoOauth(query: string, hash: string): RetornoOauth {
  // `URLSearchParams` aceita a string com ou sem o separador na frente para a query, mas
  // NAO remove o `#` do fragmento sozinho: sem este `replace`, a primeira chave viria
  // com o `#` colado no nome e nunca casaria.
  const daQuery = new URLSearchParams(query.replace(/^\?/, ''));
  const daHash = new URLSearchParams(hash.replace(/^#/, ''));

  // A QUERY TEM PRECEDENCIA, e a ordem e decidida e nao acidental: sem isto, uma troca de
  // ordem no codigo mudaria a mensagem sem ninguem notar.
  const codigo = daQuery.get('error_code') ?? daHash.get('error_code');
  const tipo = daQuery.get('error') ?? daHash.get('error');
  if (!codigo && !tipo) return 'sem-erro';

  /**
   * CANCELAR NAO E ERRO, e tratar como erro seria mentir para quem cancelou de proposito.
   *
   * `bad_oauth_state` chega quando a pessoa aperta Cancelar, e tambem quando a tentativa
   * ficou aberta tempo demais e o estado expirou. `access_denied` e o "nao autorizo"
   * explicito. Nos dois casos o sistema funcionou: quem decidiu foi a pessoa.
   */
  if (codigo === 'bad_oauth_state' || tipo === 'access_denied') return 'escolha-da-pessoa';
  return 'falha';
}
